import { render, staticRenderFns } from "./AdminUpdateCurrentUser.vue?vue&type=template&id=2eb0544e&scoped=true&"
import script from "./AdminUpdateCurrentUser.vue?vue&type=script&lang=js&"
export * from "./AdminUpdateCurrentUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminUpdateCurrentUser.vue?vue&type=style&index=0&id=2eb0544e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb0544e",
  null
  
)

export default component.exports